import { t } from 'i18next';
import React from 'react';

export const emptyStateData = (children: React.ReactNode) => ({
  title: t('tagInfo'),
  imageClassName: 'img--project',
  children,
});
